import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange, totalRecords, rowsPerPage }) => {
  if (totalPages <= 1) return null;

  const start = (currentPage - 1) * rowsPerPage + 1;
  const end = Math.min(currentPage * rowsPerPage, totalRecords);

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '16px 20px', borderTop: '1px solid #f0f0f0', background: 'white',
      borderRadius: '0 0 16px 16px'
    }}>
      <div style={{ fontSize: '13px', color: '#7f8c8d' }}>
        Showing <strong>{start}–{end}</strong> of <strong>{totalRecords}</strong> records
      </div>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            padding: '6px 12px', borderRadius: '6px', border: '1px solid #ddd',
            background: currentPage === 1 ? '#f5f5f5' : 'white',
            color: currentPage === 1 ? '#bbb' : '#2c3e50',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            fontSize: '13px', fontWeight: '600'
          }}
        >← Prev</button>

        {pages.map(p => (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            style={{
              padding: '6px 12px', borderRadius: '6px', border: '1px solid #ddd',
              background: currentPage === p ? '#27ae60' : 'white',
              color: currentPage === p ? 'white' : '#2c3e50',
              cursor: 'pointer', fontSize: '13px', fontWeight: '600',
              minWidth: '36px'
            }}
          >{p}</button>
        ))}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            padding: '6px 12px', borderRadius: '6px', border: '1px solid #ddd',
            background: currentPage === totalPages ? '#f5f5f5' : 'white',
            color: currentPage === totalPages ? '#bbb' : '#2c3e50',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
            fontSize: '13px', fontWeight: '600'
          }}
        >Next →</button>
      </div>
    </div>
  );
};

export default Pagination;